import cx from 'classnames';

import { Image } from '~/components/Image';

interface Props {
  alt: string;
  src: string;
  radiusClass?: string;
  hasRadiusApplied?: boolean;
}

const PostImage = ({ alt, radiusClass, src, hasRadiusApplied }: Props) => {
  return (
    <div className={cx('w-full', hasRadiusApplied && `${radiusClass} overflow-hidden`)}>
      <Image src={src} alt={alt} maxWidth={800} loading={'eager'} aspectRatio="social" />
    </div>
  );
};

export default PostImage;
